import type {LDFlagSet} from 'launchdarkly-react-client-sdk';

import {BenchlingAction} from 'redux-stores/Action';

import {MockLaunchDarklyActionType} from './MockLaunchDarklyActions';

export interface MockLaunchDarklyState {
  flags: LDFlagSet;
}

const INITIAL_STATE: MockLaunchDarklyState = {
  flags: {},
};

export default function reduceLaunchDarkly(
  state: MockLaunchDarklyState = INITIAL_STATE,
  action: BenchlingAction
): MockLaunchDarklyState {
  switch (action.type) {
    case MockLaunchDarklyActionType.SET_FLAGS:
      return {
        ...state,
        flags: action.flags,
      };
    default:
      return state;
  }
}
